/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryBasicView } from './categoryBasicView';
import { OrganizationLink } from './organizationLink';
import { ResearcherData } from './researcherData';

export interface Researcher extends ResearcherData { 
    diseases?: Array<CategoryBasicView>;
    specialty?: Array<CategoryBasicView>;
}